export * from './app-date.component';



// WEBPACK FOOTER //
// ./src/app/components/app-date/index.ts